import React from 'react';
import {Link, withRouter} from 'react-router-dom'
// import Can from "../../utils/roles";

function DrawerLinkActiveClass(props){
    if(props.children !== undefined){
        if(props.location.pathname.split('/').length > 2){
            if(props.location.pathname.split('/')[1] === props.link.split('/')[1])
            return 'active'

            if(props.location.pathname.split('/')[2] === props.link.split('/')[2])
            return 'active'
        }else if(props.location.pathname.split('/').length <= 2){
            if(props.location.pathname.split('/')[1] === props.link.split('/')[1])
            return 'active'
        }
    }else{
        return props.location.pathname === props.link? 'active' : ''
    }
}

const DrawerLink = (props) =>{
    // let path = props.link.split('/')
    // let pathend = path[path.length - 1]
    return(
        <div className={`drawerItem ${DrawerLinkActiveClass(props)}`}>
                <Link to={props.link}>
                    <div className={`ItemHeader ${props.Active? 'active': ''}`}>
                        <i className={`${props.icoType === undefined?'fas' : props.icoType} ${props.icon? 'fa-'+props.icon: 'fa-angle-left'}`} aria-hidden="true"></i>
                        {props.title}
                    </div>
                </Link>
            </div>
            )
            // return(
            //     <Can  target={pathend} type={"pages"}>
            //         <div className={`drawerItem ${DrawerLinkActiveClass(props)}`}>
            //             <Link to={props.link}>
            //                 <div className={`ItemHeader ${props.Active? 'active': ''}`}>
            //                     <i className={`${props.icoType === undefined?'fas' : props.icoType} ${props.icon? 'fa-'+props.icon: 'fa-angle-left'}`} aria-hidden="true"></i>
            //                     {props.title}
            //                 </div>
            //             </Link>
            //         </div>
            //     </Can>
            //         )
}
export default withRouter(DrawerLink)